import { Stack, Typography, useTheme } from '@mui/material';
import { Link } from '@rumblefish/ui/AlgeaTheme';
import React from 'react';
import type { MobileCaseBoxProps } from './MobileCaseBox.types';
import {
  StyledButton,
  StyledImage,
  StyledStack,
  StyledTextWrapper,
  StyledTitle,
} from './styles';

export const MobileCaseBox = ({
  company,
  image,
  link,
  title,
  ...props
}: MobileCaseBoxProps) => {
  const theme = useTheme();

  return (
    <StyledStack {...props}>
      <StyledImage src={image} />
      <StyledTextWrapper spacing={1}>
        <Typography
          variant="strong_300"
          sx={{
            textTransform: 'none',
            color: theme.palette.blueColors?.PLUS_1,
          }}>
          {company}
        </Typography>
        <Stack
          direction="row"
          gap={1}
          justifyContent="space-between"
          alignItems="center">
          <StyledTitle variant="display_xxs">{title}</StyledTitle>
          <Link to={link}>
            <StyledButton>Check it!</StyledButton>
          </Link>
        </Stack>
      </StyledTextWrapper>
    </StyledStack>
  );
};
